import styled from 'styled-components';
import colors from '../../../../helpers/colors';
import fonts from '../../../../helpers/fonts';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import Link from '../../../Link';
import { GridAlignedText } from '../../commonStyles/commonHeaderStyles';

export const StyledLanguageToggle = styled(Link)`
  width: 100%;
  border-top: solid 1px ${colors.neutral06};
  padding: ${spacing(2)};
  background-color: ${colors.neutral08};

  ${mediaQuery.tabletLandscape`
    border: none;
  `};
`;

export const LanguageText = styled(GridAlignedText)`
  ${fonts.paragraph}
  text-decoration: underline;
  color: ${colors.core01};

  ${mediaQuery.tabletLandscape`
    max-width: none;
    margin: none;
  `};
`;
